module.exports = __webpack_public_path__ + "static/media/psurveylogo.f220b4a9.svg";